import {
  ArrowLeft,
  Globe,
  Banknote,
  MapPin,
  HelpCircle,
} from "lucide-react";

import { Fragment, useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { v4 as uuid } from "uuid";
import { validateSessionAndJwtToken } from "../../../utils/validateTokenSession";
import { AcciValPage } from "./AcciValPage";
import { ToggleApiPaymentsService } from "../../../services/toggle_api_payments/toggle_api_payments.service";
import { AwaitPaymentModal } from "../../../components/modals/ModalCobreAwaitPayment";
import { FeaturesMethodPage } from "./features";
import { HttpRequest } from "../../../services/httpRequest";
import { returnToSignin } from "../../../utils/returnToSign";
import { DashboardMyCredit } from "../../../components/backgrounds/DashboardMyCredit";
import { useCredit } from "../../../context/creditContext";
import { SuccessAlert } from "../../../components/alerts/successAlert";
import { ErrorAlert } from "../../../components/alerts/errorAlert";
import { WompiHelper } from "./helpers/wompi-helper";
import { checkCreditPayable, isPaymentBlocked } from "./helpers/payment-gate";
import { useMobileDetection } from "../../../hooks/use-mobile-detection";
import { ModalWompiButton } from "../../../components/modals/ModalWompiButton";
import { WompiCheckout } from "./components/wompi_checkout";
import { useCreditPaymentIDB } from "../../../hooks/use-credit-payment";
import { SkeletonPayloginPage } from "./components/skeleton_paylogin_page";
import { ChargesTooltip } from "./components/ChargesTooltip";
import { IndexedDBService } from "../../../services/indexedDbService";
import VisaLogo from "../../flujo/nuevo_formulario/bankFlowSelector/cardComponents/logoVisa";
import MastercardLogo from "../../flujo/nuevo_formulario/bankFlowSelector/cardComponents/logoMasterCard";

const apiPaymentsDefault = "ACCIVAL";
const wompiHelper = new WompiHelper();
const indexedDbService = new IndexedDBService();

export function NewMethodsPage() {
  const [dataFromLocation, setDataFromLocation] = useState(null);
  const { disclosures, creditInfo, due } = useCredit();
  const { getCreditPayment } = useCreditPaymentIDB();
  const navigate = useNavigate();
  useLocation();
  const [isLoading, setIsLoading] = useState(true);
  const [, setFeatures] = useState([]);
  const [apiPayments, setApiPayments] = useState(apiPaymentsDefault);
  const [showModalAwaitPayment, setShowModalAwaitPayment] = useState(false);
  const [returnAccivalPage, setReturnAccivalPage] = useState(false);
  const [modalMessagetitle, setModalMessagetitle] = useState(
    "Estamos redirigiendo hacia la pasarela de pago ...",
  );
  const [globalAmount, setGlobalAmount] = useState("");
  const [concatExtendPayData, setConcatExtendPayData] = useState("");
  const [viewalert, setViewalert] = useState(false);
  const [messsageAlert, setMessageAlert] = useState("");
  const [isOpenSuccess, setIsOpenSuccess] = useState(false);
  const [isOpenError, setIsOpenError] = useState(false);
  const [wompiParams, setWompiParams] = useState({
    reference: "",
    signature_integrity: "",
    amountInCents: 0,
  });
  const [showWompiButton, setShowWompiButton] = useState(false);
  const [fullName, setFullName] = useState("");
  const [creditId] = useState(localStorage.getItem("credit_id"));

  const [metodo, setMetodo] = useState("online");
  const [subMetodo, setSubMetodo] = useState(null);
  const [subMetodoUrl, setSubMetodoUrl] = useState(null);
  const [isValidatingReference, setIsValidatingReference] = useState(false);
  const { isDesktop } = useMobileDetection();

  const infoMetoOnline = [
    {
      id: "Paga en línea, rapido, seguro y fácil.",
      label: "Paga en línea, rapido, seguro y fácil.",
    },
    {
      id: "Verificación de tu pago inmediato.",
      label: "Verificación de tu pago inmediato.",
    },
    {
      id: "Puedes renovar tu crédito al instante.",
      label: "Puedes renovar tu crédito al instante.",
    },
  ];
  const infoMetoEfectivo = [
    {
      id: "Paga en efectivo en un corresponsal Bancolombia.",
      label: "Paga en efectivo en un corresponsal Bancolombia.",
    },
    {
      id: "Verificación de tu pago en hasta 1 día hábil.",
      label: "Verificación de tu pago en hasta 1 día hábil.",
    },
    {
      id: "Renueva tu crédito en hasta 2 días hábiles.",
      label: "Renueva tu crédito en hasta 2 días hábiles.",
    },
  ];

  const cashLocations = [
    // {
    //   id: "bancolombia",
    //   label: "Bancolombia",
    //   desc: "Pago en sucursal o corresponsal",
    //   icon: Building2,
    //   imagen: "/png/bancolombia.png",
    // },
    {
      id: "efecty",
      label: "Efecty",
      desc: "Punto Efecty mas cercano",
      icon: MapPin,
      imagen: "/png/efecty.png",
      height: "1rem",
      width: "2.6rem",
    },
    // {
    //   id: "western-union",
    //   label: "Western Union",
    //   desc: "Agencia Western Union",
    //   icon: Landmark,
    //   imagen: "/png/wu-accival.png",
    //   height: "1rem",
    //   width: "2.6rem",
    // },
  ];

  const handleOpenAlert = (type, message, isOpen) => {
    if (type === "success") {
      setMessageAlert(message);
      setIsOpenSuccess(isOpen);
      setViewalert(isOpen);
    }
    if (type === "error") {
      setMessageAlert(message);
      setIsOpenError(isOpen);
      setViewalert(isOpen);
    }
  };

  const handleClearStateAlert = () => {
    setViewalert(false);
    setMessageAlert("");
    setIsOpenSuccess(false);
    setIsOpenError(false);
  };

  let randomDate = "01/01/1992";

  const loadTogglePayment = async () => {
    try {
      const data = await ToggleApiPaymentsService.getData();
      return data.message.data;
    } catch (error) {
      console.log(error);
    }
  };

  const loadInfoUser = async () => {
    try {
      const data = await HttpRequest.getInfoUser(localStorage.getItem("doc"));
      return data.message.info;
    } catch (error) {
      console.log(error);
    }
  };

  const toggleShowModal = () => {
    setShowModalAwaitPayment(!showModalAwaitPayment);
  };

  const loadInfo = async () => {
    let info = await loadInfoUser();
    return info;
  };

  // El backend valida que el crédito pueda recibir pagos antes de dejar continuar — si no puede,
  // se muestra el mensaje y no se navega a la referencia.
  const handleClickReferenceChash = async () => {
    if (isValidatingReference) return;
    setIsValidatingReference(true);
    handleClearStateAlert();
    try {
      // El tipo de pago (novación o no) se guardó al elegir la opción en /pagar.
      const creditPaymentStored = await getCreditPayment(creditId);
      const response = await HttpRequest.generateEfectyReference(
        creditId,
        creditPaymentStored?.hasExtend === true,
      );
      if (response.error) {
        handleOpenAlert("error", response.message, true);
        return;
      }
      navigate(subMetodoUrl);
      handleAddDataIndexDb("methodPyment", { subMetodo });
    } finally {
      setIsValidatingReference(false);
    }
  };

  const handleClickBtnCobre = async () => {
    try {
      toggleShowModal();
      handleClearStateAlert();
      setReturnAccivalPage(false);

      if (apiPayments === "WOMPI") {
        try {
          await handleBusinessLogicWompi();
          return;
        } catch (error) {
          // Rechazo de negocio (el crédito aún no puede pagar): se muestra el mensaje y se corta —
          // NO se cae a Accival, que dejaría pagar por otra pasarela lo que acá se bloqueó.
          if (isPaymentBlocked(error)) {
            setShowModalAwaitPayment(false);
            handleOpenAlert("error", error.message, true);
            return;
          }
          console.log(`Error al intentar pagar con Wompi: ${error}`);
          setReturnAccivalPage(true);
          return;
        }
      } else {
        // Accival no pasa por el backend para generar nada, pero igual se valida antes de mostrarlo.
        const creditPaymentStored = await getCreditPayment(creditId);
        const payable = await checkCreditPayable(
          creditId,
          creditPaymentStored?.hasExtend === true,
        );
        if (!payable.ok) {
          setShowModalAwaitPayment(false);
          handleOpenAlert("error", payable.message, true);
          return;
        }
        setReturnAccivalPage(true);
        return;
      }
    } catch (error) {
      console.log(error);
      setModalMessagetitle("");
      setReturnAccivalPage(true);
      return;
    }
  };

  const handleBusinessLogicWompi = async () => {
    try {
      const amountInCents = wompiHelper.convertAmountToCents(globalAmount);
      const creditPaymentStored = await getCreditPayment(creditId);

      // El documento ya no viaja: el backend lo toma del JWT.
      let payload = {
        creditId: localStorage.getItem("credit_id"),
        amountInCents: amountInCents,
        hasNovation: creditPaymentStored?.hasExtend,
        novationDate: creditPaymentStored?.dateExtend,
      };

      let response = await wompiHelper.generateCheckout(payload);

      if (response.error) {
        throw response;
      }

      let reference = response.reference;
      let signature_integrity = response.signature_integrity;
      setWompiParams({
        reference,
        signature_integrity,
        amountInCents: amountInCents,
        fullName: fullName,
        email: localStorage.getItem("email"),
        phone: localStorage.getItem("phone"),
        documento: localStorage.getItem("doc"),
      });
      setShowModalAwaitPayment(false);
      setShowWompiButton(true);
      return;
    } catch (error) {
      throw error;
    }
  };

  const handleAddDataIndexDb = async (id, data) => {
    try {
      let item = await indexedDbService.findItem("id", id);
      if (item) {
        indexedDbService.updateItem(id, data);
      } else {
        await indexedDbService.updateItem(id, data);
      }
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    const validSessionAndTokenJwt = async () => {
      try {
        return await validateSessionAndJwtToken();
      } catch {
        return false;
      }
    };

    const loadTogglePayments = async () => {
      try {
        return await loadTogglePayment();
      } catch (error) {
        console.log(error);
        return [];
      }
    };

    (async () => {
      try {
        const isValidToken = await validSessionAndTokenJwt();

        if (!isValidToken) {
          return returnToSignin(navigate);
        }

        // ---- 1) Cargar info del usuario ----
        const info = await loadInfo();
        const fullName = `${info?.firstname} ${info?.firstlastname}`;
        setFullName(fullName);

        // ---- 2) Resolver datos (location → IndexedDB → fallback) ----
        let data;
        try {
          data = await indexedDbService.findItem(
            "id",
            localStorage.getItem("credit_id"),
          );
          if (!data) return;
          setDataFromLocation(data);
        } catch (error) {
          console.error(error);
          return navigate("/pagar");
        }

        // ---- 3) Definir monto final ----

        setGlobalAmount(data.amount);

        // ---- 4) Reconstruir concatExtendPayData ----
        const hasExtend = data?.hasExtend ?? false;

        if (hasExtend !== undefined) {
          const dateExtend = data?.dateExtend ?? randomDate;

          setConcatExtendPayData(
            `${hasExtend};${dateExtend};${localStorage.getItem("doc")}`,
          );
        }

        // ---- 5) Features y toggle de pagos ----
        setFeatures(FeaturesMethodPage({ extendPlazo: hasExtend }));

        const toggleApiPayments = await loadTogglePayments();
        const _apiPayments = toggleApiPayments[0];

        if ("apiPayments" in _apiPayments) {
          setApiPayments(_apiPayments.apiPayments);
        }

        setIsLoading(false);
      } catch (e) {
        console.log(e);
        returnToSignin(navigate);
      }
    })();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  if (isLoading) {
    return <SkeletonPayloginPage title={"¿Como quieres pagar?"}/>;
  }

  return (
    <Fragment>
      {viewalert && (
        <>
          <SuccessAlert
            isOpen={isOpenSuccess}
            message={messsageAlert}
          ></SuccessAlert>
          <ErrorAlert
            isOpen={isOpenError}
            message={messsageAlert}
            isDesktop={isDesktop}
          ></ErrorAlert>
        </>
      )}
      <DashboardMyCredit
        current3={true}
        name={dataFromLocation?.name}
        current={"2"}
        balance={dataFromLocation?.amount}
        title={"¿Como quieres pagar?"}
        disclosures={disclosures}
        creditInfo={creditInfo}
        due={due}
        justify={"center"}
        flexWrap={"wrap"}
        display={"flex"}
        height={"97%"}
        main={
          <div className="bg-gray-100 flex items-center justify-center px-4 mb-40 md:mb-0">
            {/* CARD */}
            <div className="flex flex-col h-full w-auto bg-white px-8 py-5 rounded-3xl shadow-lg mt-8 md:w-125">
              {/* HEADER */}
              <div className="flex items-center justify-between px-1 mb-6">
                <button
                  onClick={() => {
                    navigate(-1);
                  }}
                  style={{ cursor: "pointer" }}
                  className="p-2 -ml-2 rounded-full hover:bg-gray-100 transition-colors"
                  aria-label="Volver"
                >
                  <ArrowLeft className="size-5 text-gray-600" />
                </button>
              </div>
              <h2 className="text-xl font-bold text-gray-900">
                Metodo de pago
              </h2>
              <p className="text-gray-500 text-sm mb-6">
                Selecciona como deseas pagar
              </p>
              {/* ================= METODOS PRINCIPALES ================= */}
              {/* Pago en línea */}
              <div
                className={`flex-1 overflow-y-auto  2xl:flex-none 2xl:h-64.25 2xl:p-5 min-[1920px]:p-5 ${metodo === "efectivo" ? "min-[1920px]:h-90.25" : "min-[1920px]:h-62.5"}`}
              >
                <div
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    gap: "10px",
                  }}
                >
                  <div
                    onClick={() => {
                      setMetodo("online");
                      setSubMetodo(null);
                    }}
                    style={{
                      border:
                        metodo === "online"
                          ? "1px solid #7f22fe"
                          : "1px solid #faf9ff",
                      padding: "20px 15px",
                      justifyContent: "space-between",
                      cursor: "pointer",
                    }}
                    className={`flex items-center justify-between rounded-2xl bg-white p-4 shadow-xs hover:shadow-md transition`}
                  >
                    <div className="flex items-center gap-4">
                      <div
                        className={`flex h-12 w-12 items-center justify-center rounded-xl bg-indigo-100 text-indigo-600  ${metodo === "online" ? "bg-[#7f22fe]" : "bg-[#f3f4f6]"
                          }`}
                      >
                        <Globe
                          className={`size-5 ${metodo === "online"
                            ? "text-white"
                            : "text-[#414244]"
                            }`}
                          strokeWidth={2}
                        />
                      </div>
                      <div>
                        <div className="text-gray-900 flex flex-row items-center gap-1">
                          Pago en Wompi
                          <ChargesTooltip
                            icon={
                              <HelpCircle
                                className="size-4 text-gray-400 hover:text-gray-600 cursor-pointer"
                                strokeWidth={2}
                                onClick={(e) => e.stopPropagation()}
                              />
                            }
                            title="VENTAJAS"
                            items={infoMetoOnline.map((c) => ({
                              label: c.label,
                              id: c.id,
                            }))}
                            isInfo={true}
                          />
                        </div>
                        <div className="flex gap-2 items-center">
                          {/* <p className="text-sm text-[#6c6d6f] flex"> */}
                          {/* <span className="flex flex-col items-center bg-red">
                              
                            </span> */}
                          {/* <img src={homologateBankNameAccount(21, "iconName")} className="w-4 h-4 bg-red" /> */}
                          {/* </p> */}
                          <img src="/png/bancolombia.png" className="w-8 h-8" alt="Bancolombia" />
                          <img src="/png/pse.png" className="w-8 h-8" alt="PSE" />
                          <VisaLogo colorBase="#7e02fc" />

                          <MastercardLogo size={32} />
                          {/* <p className="text-sm text-[#6c6d6f]">
                            <img />
                            PSE
                          </p> */}
                        </div>
                      </div>
                    </div>
                    <div
                      className={`w-6 h-6 rounded-full border flex justify-center items-center ${metodo === "online"
                        ? "border-[#7f22fe] bg-[#7f22fe]"
                        : "border-[#b2b5bb]"
                        }`}
                    >
                      {metodo === "online" && (
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="15"
                          height="15"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="white"
                          strokeWidth="3"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        >
                          <polyline points="20 6 9 17 4 12" />
                        </svg>
                      )}
                    </div>
                  </div>

                  <div
                    onClick={() => setMetodo("efectivo")}
                    style={{
                      border:
                        metodo === "efectivo"
                          ? "1px solid #7f22fe"
                          : "1px solid #faf9ff",
                      padding: "20px 15px",
                      justifyContent: "space-between",
                      cursor: "pointer",
                    }}
                    className={`flex items-center justify-between rounded-2xl bg-white p-4 shadow-xs hover:shadow-md transition ${metodo === "efectivo"
                      ? "border-[#7f22fe]"
                      : "border-[#faf9ff]"
                      }`}
                  >
                    <div className="flex items-center gap-4">
                      <div
                        className={`flex h-12 w-12 items-center justify-center rounded-xl bg-indigo-100 text-indigo-600 ${metodo === "efectivo"
                          ? "bg-[#7f22fe]"
                          : "bg-[#f3f4f6]"
                          }`}
                      >
                        <Banknote
                          className={`size-5 ${metodo === "efectivo"
                            ? "text-white"
                            : "text-[#414244]"
                            }`}
                          strokeWidth={2}
                        />
                      </div>

                      <div>
                        <div className="text-gray-900 flex flex-row items-center gap-1">
                          Pago en efectivo
                          <ChargesTooltip
                            icon={
                              <HelpCircle
                                className="size-4 text-gray-400 hover:text-gray-600 cursor-pointer"
                                strokeWidth={2}
                                onClick={(e) => e.stopPropagation()}
                              />
                            }
                            title="VENTAJAS"
                            items={infoMetoEfectivo.map((c) => ({
                              label: c.label,
                              id: c.id,
                            }))}
                            isInfo={true}
                          />
                        </div>
                        <img src="/png/efecty.png" className="w-14 h-4" alt="Efecty" />
                      </div>
                    </div>
                    <div
                      className={`w-6 h-6 rounded-full border flex justify-center items-center ${metodo === "efectivo"
                        ? "border-[#7f22fe] bg-[#7f22fe]"
                        : "border-[#b2b5bb]"
                        }`}
                    >
                      {metodo === "efectivo" && (
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="15"
                          height="15"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="white"
                          strokeWidth="3"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        >
                          <polyline points="20 6 9 17 4 12" />
                        </svg>
                      )}
                    </div>
                  </div>
                </div>
                {/* ================= SUBMETODOS ================= */}
                {metodo === "efectivo" && (
                  <div
                    className="mt-5"
                    style={{
                      gap: "5px",
                      display: "flex",
                      flexDirection: "column",
                    }}
                  >
                    <p className="text-gray-700 font-medium mb-3">
                      Selecciona donde pagar
                    </p>

                    {cashLocations.map((item) => {
                      const Icon = item.icon;

                      return (
                        <div
                          key={item.id}
                          onClick={() => {
                            setSubMetodo(item.id);
                            setSubMetodoUrl("/referencia-efectivo");
                          }}
                          style={{
                            border:
                              subMetodo === item.id
                                ? "1px solid #7f22fe"
                                : "1px solid #faf9ff",
                            padding: "10px 15px",
                            justifyContent: "space-between",
                            cursor: "pointer",
                          }}
                          className={`flex items-center justify-between rounded-2xl bg-white p-4 shadow-xs hover:shadow-md transition gap ${subMetodo === item.id
                            ? "border-[#7f22fe]"
                            : "border-[#faf9ff]"
                            }`}
                        >
                          <div className="flex items-center gap-4">
                            <div
                              className={`flex h-12 w-12 items-center justify-center rounded-xl bg-indigo-100 text-indigo-600 ${subMetodo === item.id
                                ? "bg-[#7f22fe]"
                                : "bg-[#f3f4f6]"
                                }`}
                            >
                              <Icon
                                className={`size-5 ${subMetodo === item.id
                                  ? "text-white"
                                  : "text-[#414244]"
                                  }`}
                                strokeWidth={2}
                              />
                            </div>

                            <div>
                              <p className="font-medium text-[#414244">
                                {/* {item.label} */}
                                <img
                                  className="mx-auto md:mx-0 w-12 h-4"
                                  src={item.imagen}
                                  alt={item.label}
                                />
                              </p>
                              <p className="text-sm text-gray-500">
                                {item.desc}
                              </p>
                            </div>
                          </div>
                          <div
                            className={`w-6 h-6 rounded-full border flex justify-center items-center ${subMetodo === item.id
                              ? "border-[#7f22fe] bg-[#7f22fe]"
                              : "border-[#b2b5bb]"
                              }`}
                          >
                            {subMetodo === item.id && (
                              <svg
                                xmlns="http://www.w3.org/2000/svg"
                                width="15"
                                height="15"
                                viewBox="0 0 24 24"
                                fill="none"
                                stroke="white"
                                strokeWidth="3"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              >
                                <polyline points="20 6 9 17 4 12" />
                              </svg>
                            )}
                          </div>
                        </div>
                      );
                    })}
                  </div>
                )}
              </div>
              {/* ================= BOTON ================= */}

              <button
                className="mt-6 w-full font-semibold py-4 rounded-full text-white border-[#7f22fe] bg-[#7f22fe] hover:opacity-90 transition flex items-center justify-center gap-4"
                onClick={() => {
                  metodo === "online"
                    ? handleClickBtnCobre()
                    : handleClickReferenceChash();
                }}
                disabled={
                  (metodo === "efectivo" && subMetodo === null) ||
                  isValidatingReference
                }
                style={{
                  opacity: isValidatingReference ? 0.7 : 1,
                  backgroundColor:
                    metodo === "efectivo" && subMetodo === null
                      ? "#d2d5d9"
                      : "#7f22fe",
                  cursor:
                    metodo === "efectivo" && subMetodo === null
                      ? "not-allowed"
                      : "pointer",
                }}
              >
                {metodo === "online" ? (
                  <>
                    <span>Pagar ahora</span>{" "}
                    {/* <ChevronRight className={`size-5 text-white`} strokeWidth={2} /> */}
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="20"
                      height="20"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <path d="M5 12h14" />
                      <path d="m12 5 7 7-7 7" />
                    </svg>
                  </>
                ) : subMetodo ? (
                  <>
                    <span className=" w-37.5 md:w-auto">
                      Generar referencia de{" "}
                      {subMetodo === "bancolombia" && "Bancolombia"}
                      {subMetodo === "efecty" && "Efecty"}
                      {subMetodo === "western-union" && "Western Union"}
                    </span>{" "}
                    {/* <ChevronRight className={`size-5 text-white`} strokeWidth={2} /> */}
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="20"
                      height="20"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <path d="M5 12h14" />
                      <path d="m12 5 7 7-7 7" />
                    </svg>
                  </>
                ) : (
                  <>
                    <span>Seleccione una referencia</span>{" "}
                    {/* <ChevronRight className={`size-5 text-white`} strokeWidth={2} /> */}
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="20"
                      height="20"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <path d="M5 12h14" />
                      <path d="m12 5 7 7-7 7" />
                    </svg>
                  </>
                )}
              </button>
              <button
                className="w-full py-3 text-sm font-semibold text-[#8b94a3] hover:text-[#4e5052] transition-colors"
                onClick={() => {
                  navigate(-1);
                }}
                style={{ cursor: "pointer" }}
              >
                Cancelar
              </button>
            </div>

            {showWompiButton && (
              <ModalWompiButton
                isOpen={showWompiButton}
                title={"Pagar ahora con Wompi"}
                messageTitle={""}
                ContentAction={
                  <WompiCheckout
                    amountInCents={wompiParams.amountInCents}
                    reference={wompiParams.reference}
                    signature={wompiParams.signature_integrity}
                    email={wompiParams.email}
                    fullName={wompiParams.fullName}
                    phone={wompiParams.phone}
                    documento={wompiParams.documento}
                  />
                }
                showContentAction={true}
                onHide={() => setShowWompiButton(false)}
              ></ModalWompiButton>
            )}

            {showModalAwaitPayment && (
              <AwaitPaymentModal
                isOpen={showModalAwaitPayment}
                title={"Espere un momento."}
                messageTitle={modalMessagetitle}
                ContentAction={
                  <AcciValPage
                    payload={{
                      orderNumber: uuid(),
                      amount: globalAmount,
                      email: localStorage.getItem("email"),
                      phone: localStorage.getItem("phone"),
                      firstname: dataFromLocation?.name,
                      lastname: dataFromLocation?.lastname,
                      doctype: "4",
                      documento: localStorage.getItem("doc"),
                      orderDescription: `Pago de crédito #${localStorage.getItem(
                        "credit_id",
                      )}`,
                      additionalData: btoa(concatExtendPayData),
                    }}
                  />
                }
                showContentAction={returnAccivalPage}
                onHide={() => setShowModalAwaitPayment(false)}
              ></AwaitPaymentModal>
            )}
          </div>
        }
      />
    </Fragment>
  );
}
